import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Box,
  HStack,
  Icon,
  VStack,
} from '@chakra-ui/react';
import { overflowScrollbarStyles } from '@duke-hq/ui/styles/overflowScrollbarStyles';
import { Pin } from 'lucide-react';
import { NoteInterface } from '../types';
import { PinnedNote } from './PinnedNote';
import { Trans } from '@lingui/react/macro';

export function PinnedNotes({ notes }: { notes: NoteInterface[] }) {
  return (
    <Box bg="bg.surface" borderTop="1px solid" borderColor="border.default">
      <Accordion allowToggle defaultIndex={[0]}>
        <AccordionItem border="none">
          <AccordionButton
            bg="bg.surface"
            color="bg.accent.inverse-subtle"
            justifyContent="space-between"
            gap={2}
            position="relative"
            py={2}
            fontSize="xs"
            fontWeight="medium"
            borderTopRadius="16px"
          >
            <HStack>
              <Icon size="xs" as={Pin} />
              <Trans>Pinned Notes</Trans>
              <Badge
                rounded="full"
                w="20px"
                h="20px"
                fontSize="xs"
                alignItems="center"
                justifyContent="center"
                display="flex"
                variant="solid"
                backgroundColor="bg.accent.inverse-default"
              >
                {notes.length}
              </Badge>
            </HStack>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4} px={0} bg="bg.surface">
            <Box maxH="350px" overflowY="auto" overflowX="hidden" css={overflowScrollbarStyles}>
              <VStack spacing={3} align="stretch" px={4}>
                {notes.map((note) => (
                  <Box key={note.id}>
                    <PinnedNote {...note} />
                  </Box>
                ))}
              </VStack>
            </Box>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
}
